/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLoanEmis,
  clearLoanEmis,
} from "../redux/slices/loan/loanEmiSlice";
import {
  payLoanAdvance,
  payLoanEmi,
  payLoanEmiNew,
} from "../redux/slices/loan/PayLoanEmiSlice";
import jsPDF from "jspdf";
import "../assets/Loan/LoanEmiDetails.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import axios from "axios";

const LoanEmiDetails = () => {
  const { loanId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loan, setLoan] = useState(location.state?.loan || null);

  const { emis, customerName, loanNumber, count, loading, error } = useSelector(
    (state) => state.loanEmi,
  );

  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [paymentData, setPaymentData] = useState({
    type: "full",
    amountPaid: "",
    paymentMode: "Cash",
    paymentDate: new Date().toISOString().split("T")[0],
  });
  const [submitting, setSubmitting] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch EMI + company info
  useEffect(() => {
    if (loanId) dispatch(fetchLoanEmis(loanId));

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            data.logoUrl = `https://payyug.in/${data.logo.replace(
              /^images\//,
              "",
            )}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };

    if (profile?.superAdminId) fetchCompany();

    return () => {
      dispatch(clearLoanEmis());
    };
  }, [loanId, dispatch, profile?.superAdminId]);

  // const handleadvancepay = () => {
  //    let defaultAmount="";

  // }

  // 🟢 Payment Type Handler
  const handlePayClick = (emi, type) => {
    setSelectedEmi(emi);

    let defaultAmount = emi.totalPayable;
    if (type === "partial") defaultAmount = "";
    if (type === "advance") defaultAmount = "";

    setPaymentData({
      type,
      amountPaid: defaultAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
    });

    setShowModal(true);
  };

  // // 🟢 Submit Payment
  // const handleSubmitPayment = async () => {
  //   if (!selectedEmi) return;

  //   try {
  //     setSubmitting(true);

  //     const resultAction = await dispatch(
  //       payLoanEmi({
  //         loanId,
  //         emiNumber: selectedEmi.emiNumber || selectedEmi.id,
  //         amountPaid: paymentData.amountPaid,
  //         paymentMode: paymentData.paymentMode,
  //         paymentDate: paymentData.paymentDate,
  //         paymentType: paymentData.type, // NEW
  //       })
  //     );

  //     if (payLoanEmi.fulfilled.match(resultAction)) {
  //       alert(`✅ ${resultAction.payload.message}`);
  //       setShowModal(false);
  //       setSelectedEmi(null);
  //       dispatch(fetchLoanEmis(loanId));
  //     } else {
  //       alert(
  //         "❌ Payment failed: " +
  //           (resultAction.payload?.message || "Unknown error")
  //       );
  //     }
  //   } catch (err) {
  //     alert("❌ Payment failed: " + err.message);
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleSubmitPayment = async () => {
    if (!selectedEmi) return;

    try {
      setSubmitting(true);

      const payload = {
        loanId,
        emiNumber: selectedEmi.emiNumber || selectedEmi.id,
        amountPaid: paymentData.amountPaid,
        paymentMode: paymentData.paymentMode,
        paymentDate: paymentData.paymentDate,
      };

      let resultAction;

      // 1️⃣ FULL EMI → OLD API
      if (paymentData.type === "full") {
        resultAction = await dispatch(payLoanEmi(payload));
      }

      // 2️⃣ PARTIAL + ADVANCE → NEW API
      else if (paymentData.type === "partial") {
        resultAction = await dispatch(
          payLoanEmiNew({
            ...payload,
            paymentType: paymentData.type, // <---- ADD THIS
          }),
        );
      } else if (paymentData.type === "advance") {
        resultAction = await dispatch(
          payLoanAdvance({
            ...payload,
            paymentType: paymentData.type,
          }),
        );
      }

      if (
        payLoanEmi.fulfilled.match(resultAction) ||
        payLoanEmiNew.fulfilled.match(resultAction) ||
        payLoanAdvance.fulfilled.match(resultAction)
      ) {
        toast.success(`✅ ${resultAction.payload.message}`);
        setShowModal(false);
        setSelectedEmi(null);
        dispatch(fetchLoanEmis(loanId));
      } else {
        toast.error("❌ Payment failed");
      }
    } finally {
      setSubmitting(false);
    }
  };


const unpaidEmis = emis.filter(
  (emi) => emi.status?.toLowerCase() === "pending"
);

const isAllSelected =
  unpaidEmis.length > 0 &&
  unpaidEmis.every((emi) =>
    selectedIds.includes(emi.id)
  );

const handleSelectAll = (isChecked) => {
  const currentPageIds = emis
    .filter(
      (emi) => emi.status?.toLowerCase() === "pending"
    )
    .map((emi) => emi.id);

  setSelectedIds((prev) => {
    if (isChecked) {
      const newIds = currentPageIds.filter(
        (id) => !prev.includes(id)
      );

      return [...prev, ...newIds];
    }

    return prev.filter(
      (id) => !currentPageIds.includes(id)
    );
  });
};

const handleSelectClick = (id, isChecked) => {
  setSelectedIds((prev) => {
    if (isChecked) {
      return prev.includes(id)
        ? prev
        : [...prev, id];
    }

    return prev.filter((item) => item !== id);
  });
};

  /* ================= BULK PAY ================= */
  const handlebulkpay = async () => {
    if (selectedIds.length === 0) {
      toast.warn("Please select at least one EMI");
      return;
    }

    const isConfirmed = window.confirm(
      "Are you sure you want to pay selected EMIs?",
    );

    if (!isConfirmed) return;

    try {
      setBulkLoading(true);

      const res = await axios.post("https://payyug.in/api/loan/pay-emi-bulk", {
        emiIds: selectedIds,
        paymentMode: "Cash",
        paymentDate: new Date().toISOString().split("T")[0],
      });

      toast.success(res.data?.message || "Bulk Payment Successful");

      setSelectedIds([]);

      await dispatch(fetchLoanEmis(loanId));
    } catch (err) {
      toast.error(err.response?.data?.message || "Bulk payment failed");
    } finally {
      setBulkLoading(false);
    }
  };
  const formatDate = (d) =>
    d
      ? new Date(d).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
        })
      : "-";

  const formatCurrency = (n) =>
    `Rs. ${Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    })}`;

  // PDF + Slip Helpers
  const loadLogoAsDataURL = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

  const buildEmiSlipPDF = async (emi, serialNo) => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 30;

    const status = (emi.status || "").toLowerCase();
    if (status !== "paid" && status !== "partial") {
      alert("Slip available only for PAID or PARTIAL EMIs");
      return null;
    }

    /* ================= LOGO ================= */
    const logoDataURL = await loadLogoAsDataURL(
      company?.logoUrl || "/techvisionlogo.jpg",
    );

    const logoSize = 60;
    const logoRadius = logoSize / 2;

    const logoX = margin;
    const logoY = margin + 10;

    if (logoDataURL) {
      doc.setDrawColor(180);
      doc.circle(logoX + logoRadius, logoY + logoRadius, logoRadius + 3);
      doc.addImage(logoDataURL, "PNG", logoX, logoY, logoSize, logoSize);
    }

    const textBoxX = margin + logoSize + 20;
    const textBoxWidth = pageWidth - textBoxX - margin;

    const textCenterX = textBoxX + textBoxWidth / 2;

    let headerY = margin + 28;

    doc.setFont("helvetica", "bold").setFontSize(18);

    const nameLines = doc.splitTextToSize(
      company?.name || "TechVision Finance",
      textBoxWidth,
    );

    doc.text(nameLines, textCenterX, headerY, {
      align: "center",
    });

    headerY += nameLines.length * 22;

    doc.setFont("helvetica", "normal").setFontSize(11);

    const addressLines = doc.splitTextToSize(
      company?.address || "--",
      textBoxWidth,
    );

    doc.text(addressLines, textCenterX, headerY, {
      align: "center",
    });

    headerY += addressLines.length * 14 + 6;

    doc.text(
      `Email: ${company?.email || "-"} | Contact: ${company?.contact || "-"}`,
      textCenterX,
      headerY,
      { align: "center" },
    );

    /* ================= TITLE (BORDER ABOVE) ================= */
    const titleY = Math.max(logoY + logoSize + 25, headerY + 25);

    // 🔹 border ABOVE title
    doc.setDrawColor(180);
    doc.line(margin, titleY - 15, pageWidth - margin, titleY - 15);

    // 🔹 title
    doc.setFont("helvetica", "bold").setFontSize(15);
    doc.text("EMI PAYMENT SLIP", pageWidth / 2, titleY, {
      align: "center",
    });

    let y = titleY + 30;

    /* ================= BASIC INFO TABLE ================= */
    const basicInfo = [
      ["Customer Name", customerName],
      ["Loan No", loanNumber],
      ["EMI No", emi.emiNumber],
      ["Due Date", formatDate(emi.dueDate)],
      ["Paid Date", emi.paymentDate ? formatDate(emi.paymentDate) : "-"],
      ["Status", emi.status?.toUpperCase()],
    ];

    drawTable(doc, margin, y, pageWidth - margin * 2, basicInfo);
    y += basicInfo.length * 28 + 20;

    /* ================= EMI AMOUNT TABLE ================= */
    const emiAmount = Number(emi.emiAmount || 0);
    const penalty = Number(emi.penaltyAmount || 0);
    const total = emiAmount + penalty;

    const amountInfo = [
      ["EMI Amount", emiAmount.toFixed(2)],
      ["Penalty Amount", penalty.toFixed(2)],
      ["Total Amount", total.toFixed(2)],
    ];

    drawTable(doc, margin, y, pageWidth - margin * 2, amountInfo, true);
    y += amountInfo.length * 28 + 20;

    /* ================= PARTIAL PAYMENTS TABLE ================= */
    const partials = [];
    for (let i = 1; i <= 5; i++) {
      const amt = Number(emi[`payment${i}`] || 0);
      if (amt > 0) {
        partials.push([
          i,
          amt.toFixed(2),
          formatDate(emi[`payment${i}Date`]),
          emi[`payment${i}Mode`] || "-",
        ]);
      }
    }

    if (partials.length) {
      doc.setFont("helvetica", "bold").setFontSize(14);
      doc.text("Partial Payments", margin, y);
      y += 15;

      drawGridTable(
        doc,
        margin,
        y,
        pageWidth - margin * 2,
        ["No", "Amount", "Paid Date", "Mode"],
        partials,
      );

      y += partials.length * 24 + 40;
    }

    /* ================= OUTSTANDING ================= */
    doc.setFont("helvetica", "bold").setFontSize(13);
    doc.text("Outstanding Balance", margin, y);
    doc.text(Number(emi.outstanding || 0).toFixed(2), pageWidth - margin, y, {
      align: "right",
    });

    y += 40;

    /* ================= FOOTER ================= */
    doc.setFont("helvetica", "italic").setFontSize(10);
    doc.text(
      "This is a system generated EMI slip. No signature required.",
      pageWidth / 2,
      y,
      { align: "center" },
    );

    return doc;
  };

  const drawTable = (doc, x, y, tableWidth, rows, highlightLast = false) => {
    const col1Width = tableWidth * 0.35;
    const col2Width = tableWidth * 0.65;
    const minRowHeight = 26;
    let currentY = y;

    doc.setFontSize(11);

    rows.forEach((row, index) => {
      const label = String(row[0] || "");
      const value = String(row[1] || "-");

      // 🔹 Wrap text
      const wrappedLabel = doc.splitTextToSize(label, col1Width - 10);
      const wrappedValue = doc.splitTextToSize(value, col2Width - 10);

      // 🔹 Calculate dynamic row height
      const rowHeight =
        Math.max(wrappedLabel.length, wrappedValue.length) * 14 + 10;

      // 🔹 Border
      doc.rect(x, currentY, col1Width, rowHeight);
      doc.rect(x + col1Width, currentY, col2Width, rowHeight);

      // 🔹 Highlight last row (optional)
      if (highlightLast && index === rows.length - 1) {
        doc.setFont("helvetica", "bold");
      } else {
        doc.setFont("helvetica", "normal");
      }

      // 🔹 Text
      doc.text(wrappedLabel, x + 5, currentY + 16);
      doc.text(wrappedValue, x + col1Width + 5, currentY + 16);

      currentY += rowHeight;
    });
  };

  const drawGridTable = (doc, x, y, width, headers, body) => {
    const rowH = 24;
    const colW = width / headers.length;

    doc.setFont("helvetica", "bold");
    headers.forEach((h, i) => {
      doc.rect(x + i * colW, y, colW, rowH);
      doc.text(h, x + i * colW + 6, y + 16);
    });

    doc.setFont("helvetica", "normal");
    body.forEach((row, r) => {
      row.forEach((cell, c) => {
        doc.rect(x + c * colW, y + (r + 1) * rowH, colW, rowH);
        doc.text(String(cell), x + c * colW + 6, y + (r + 1) * rowH + 16);
      });
    });
  };

  const generateEmiSlipPDF = async (emi, serialNo) => {
    const doc = await buildEmiSlipPDF(emi, serialNo);
    if (!doc) return;
    doc.save(`EMI_Slip_${loanNumber}_EMI${emi.emiNumber || serialNo}.pdf`);
  };

  const previewEmiSlipPDF = async (emi, serialNo) => {
    const doc = await buildEmiSlipPDF(emi, serialNo);
    if (!doc) return;
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    setPreviewUrl(url);
    setShowPreview(true);
  };

  if (loading) return <p>Loading EMI Schedule...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="viewemiloandata-container">
      {/* Header */}
      <header className="viewemiloandata-headerbar">
        <div className="viewemiloandata-company">
          <img
            src={company?.logoUrl || "/techvisionlogo.jpg"}
            alt="Company Logo"
            className="viewemiloandata-logo"
          />
          <div className="viewemiloanddata-company-details">
            <h2 className="viewemiloandata-companyname">
              {company?.name || "TechVision Finance"}
            </h2>
            <p>{company?.tagline || "Trusted Loan Partner"}</p>
            <p>
              <strong>Email:</strong> {company?.email}
            </p>
            <p>
              <strong>Phone:</strong> {company?.contact}
            </p>
          </div>
        </div>
      </header>

      {/* Loan Info */}
      <div className="viewemiloandata-loaninfo">
        <h3>Loan & Customer Details</h3>
        <p>
          <strong>Customer:</strong> {customerName}
        </p>
        <p>
          <strong>Loan Account No:</strong> {loanNumber}
        </p>
        <p>
          <strong>Total EMIs:</strong> {count}
        </p>
        <p>
          <strong>Advance Paid:</strong> {loan.unusedAmount}
        </p>
      </div>

      {/* EMI Table */}
      <div className="viewemiloandata-table-container">
        <div className="table-cap">
          <h3>Loan EMI Schedule</h3>
          <div className="">
            <button
              className="adv-pay-btn"
              onClick={() => handlePayClick(emis[0], "advance")}
            >
              Adv. Payment
            </button>
            <button
              className="filter-btn"
              disabled={bulkLoading}
              onClick={handlebulkpay}
            >
              {bulkLoading ? "Processing..." : "Bulk Pay"}
            </button>
          </div>
        </div>

        {emis.length === 0 ? (
          <p>No EMIs found</p>
        ) : (
          <div className="viewemiloandata-table-wrapper">
            <table className="viewemiloandata-table">
              <thead>
                <tr>
                  <th>EMI No</th>
                  <th>Due Date</th>
                  <th>Emi Amount</th>
                  <th>Penalty Amount</th>
                  <th>Status</th>
                  <th>Paid Date</th>
                  <th>Action</th>
                  <th>Slip</th>
                  <th
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignContent: "center",
                    }}
                  >
                    Select For All EMI Pay{" "}
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  </th>
                </tr>
              </thead>

              <tbody>
                {emis.map((emi, i) => {
                  const isPaid = emi.status?.toLowerCase() === "paid";
                  const isPartial = emi.status?.toLowerCase() === "partial";
                  const isPending = emi.status?.toLowerCase() === "pending";
                  const nextemi = i < emis.length - 1 ? emis[i + 1] : null;
                  return (
                    <tr
                      key={emi.id}
                      className="emi-row"
                      style={{
                        background: isPaid
                          ? "#e8f7e8"
                          : isPartial
                            ? "#fff6e0"
                            : "#ffecec",
                      }}
                    >
                      <td>{emi.emiNumber}</td>

                      <td>{formatDate(emi.dueDate)}</td>

                      <td>
                        {formatCurrency(emi.emiAmount)}

                        <div className="emi-small">
                          <span>
                            Principal: {formatCurrency(emi.principalComponent)}
                          </span>
                          <br />
                          <span>
                            Interest: {formatCurrency(emi.interestComponent)}
                          </span>
                        </div>
                      </td>
                      <td>
                        {formatCurrency(
                          emi.penaltyAmount === 0
                            ? emi.penalty
                            : emi.penaltyAmount,
                        ) || "N/A"}
                      </td>

                      <td style={{ fontWeight: "bold" }}>
                        {isPaid && <span style={{ color: "green" }}>Paid</span>}
                        {isPartial && (
                          <span style={{ color: "#ff9800" }}>Partial</span>
                        )}
                        {isPending && (
                          <span style={{ color: "red" }}>Pending</span>
                        )}

                        {/* partial details */}
                        {isPartial && (
                          <div className="emi-small">
                            Paid: {formatCurrency(emi.partiallyPaidAmount)}{" "}
                            <br />
                            Remaining: {formatCurrency(emi.emiBalance)}
                          </div>
                        )}

                        {/* last payment details */}
                        {isPaid && emi.lastPaidAmount && (
                          <div className="emi-small">
                            Last Paid: {formatCurrency(emi.lastPaidAmount)}
                          </div>
                        )}

                        {/* outstanding */}
                        <div className="emi-small">
                          Outstanding: {formatCurrency(emi.outstanding)}
                        </div>
                      </td>

                      <td>
                        {emi.paymentDate ? formatDate(emi.paymentDate) : "-"}
                      </td>

                      {/* ACTIONS */}
                      <td>
                        {isPaid ? (
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            ✔ Paid
                          </span>
                        ) : (
                          <div className="emi-actions">
                            <button
                              className="btn-full"
                              onClick={() => handlePayClick(emi, "full")}
                            >
                              Pay Full
                            </button>

                            <button
                              className="btn-partial"
                              onClick={() => handlePayClick(emi, "partial")}
                            >
                              Partial
                            </button>

                            {/* <button className="btn-advance" onClick={() => handlePayClick(emi, "advance")}>
                Advance
              </button> */}
                          </div>
                        )}
                      </td>

                      {/* Slip */}
                      <td>
                        {isPaid ? (
                          //  <>
                          //   <button
                          //     className="btn-print"
                          //     onClick={() => generateEmiSlipPDF(emi, i + 1)}
                          //   >
                          //     Download
                          //   </button>
                          //   <button
                          //     className="btn-preview"
                          //     onClick={() => previewEmiSlipPDF(emi, i + 1)}
                          //   >
                          //     Preview
                          //   </button>
                          // </>
                          <button
                            className="loanemidetails-emi-reciept"
                            onClick={() =>
                              navigate("/Deposit/EmiDetails/Reciept", {
                                state: {
                                  emi,
                                  loanId,
                                  nextemi,
                                  unusedAmount: loan.unusedAmount,
                                },
                              })
                            }
                          >
                            Receipt
                          </button>
                        ) : (
                          <span style={{ color: "gray" }}>After Payment</span>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {emi.status.toLowerCase()==="pending" ? (
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(emi.id)}
                            onChange={(e) =>
                              handleSelectClick(emi.id, e.target.checked)
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Payment Modal */}
      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>
              {paymentData.type === "full" &&
                `Pay Full EMI (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "partial" &&
                `Partial Payment (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "advance" &&
                `Advance EMI Payment (No: ${selectedEmi?.emiNumber})`}
            </h3>

            {paymentData.type === "partial" && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Note: Partial payment accepted. Remaining amount will stay
                pending.
              </p>
            )}

            <label>
              Amount:
              <input
                type="number"
                value={paymentData.amountPaid}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    amountPaid: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>

            <label>
              Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>

            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>

              <button onClick={handleSubmitPayment} disabled={submitting}>
                {submitting ? "Processing..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Preview Modal */}
      {showPreview && previewUrl && (
        <div className="viewemiloandata-modal-overlay">
          <div
            className="viewemiloandata-modal"
            style={{ width: "80%", height: "90%" }}
          >
            <h3>Slip Preview</h3>

            <iframe
              src={previewUrl}
              style={{
                width: "100%",
                height: "80%",
                border: "none",
              }}
            />

            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowPreview(false);
                  URL.revokeObjectURL(previewUrl);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="viewemiloandata-footer">
        <p>© 2025 {company?.name || "TechVision Finance"} Pvt. Ltd.</p>
        <p>{company?.tagline || "Empowering Dreams"}</p>
      </footer>
    </div>
  );
};

export default LoanEmiDetails;
